import {HomeStockQuote} from 'client';

import {DashboardState, StatTileData} from './dashboardModel';

/** Overlay a live stock quote onto the dashboard stat scaffold. */
export const overlayStockQuote = (
  state: DashboardState,
  stock: HomeStockQuote | null | undefined
): DashboardState => {
  if (!stock || !Number.isFinite(stock.price)) {
    return state;
  }

  return {
    ...state,
    stats: state.stats.map(
      (stat): StatTileData =>
        stat.id === 'stock'
          ? {
              ...stat,
              value: `$${stock.price.toFixed(2)}`,
              delta: stock.change_percent,
              change: typeof stock.change === 'number' ? stock.change : stat.change,
              caption: 'Dropbox, Inc.',
              spark: Array.isArray(stock.intraday) ? stock.intraday : stat.spark,
            }
          : stat
    ),
  };
};
